module.exports = __webpack_public_path__ + "src/assets/textures/molar/table_w_funnel_lambert10_AO.jpg";